import React, { createContext, useContext, useState, useCallback } from 'react';
import Toast from '../components/Toast';

const NotificationContext = createContext();

export function NotificationProvider({ children }) {
  const [notifications, setNotifications] = useState([]);

  const addNotification = useCallback((type, message) => {
    const id = Date.now() + Math.random();
    setNotifications(prev => [...prev, { id, type, message }]);
  }, []);

  const showSuccess = useCallback((message) => {
    addNotification('success', message);
  }, [addNotification]);

  const showError = useCallback((message) => {
    addNotification('error', message);
  }, [addNotification]);

  const showInfo = useCallback((message) => {
    addNotification('info', message);
  }, [addNotification]);

  const showNotification = useCallback((typeOrObj, message) => {
    let type = typeOrObj;
    let msg = message;
    if (typeof typeOrObj === 'object' && typeOrObj !== null) {
      type = typeOrObj.type || 'info';
      msg = typeOrObj.message || '';
    }
    if (type === 'success') {
      showSuccess(msg);
      return;
    }
    if (type === 'error') {
      showError(msg);
      return;
    }
    if (type === 'info' || type === 'warning') {
      showInfo(msg);
      return;
    }
    addNotification(type || 'success', msg);
  }, [addNotification, showError, showSuccess, showInfo]);

  const removeNotification = useCallback((id) => {
    setNotifications(prev => prev.filter(notif => notif.id !== id));
  }, []);

  return (
    <NotificationContext.Provider value={{ showSuccess, showError, showInfo, showNotification }}>
      {children}
      
      {/* Toast Container */}
      <div className="fixed top-4 right-4 z-[100] flex flex-col gap-2">
        {notifications.map(notif => (
          <Toast
            key={notif.id}
            id={notif.id}
            type={notif.type}
            message={notif.message}
            onClose={removeNotification}
          />
        ))}
      </div>
    </NotificationContext.Provider>
  );
}

export function useNotification() {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotification must be used within NotificationProvider');
  }
  return context;
}
